import ConnectorConfigureFormStore from '../stores/connector-configure-form-store';

export const setNameInput = (value: string) => {
  ConnectorConfigureFormStore.name = value;
};

export const setAwsRoleArnInput = (value: string) => {
  ConnectorConfigureFormStore.awsRoleArn = value;
};

export const setAwsAccessKeyInput = (value: string) => {
  ConnectorConfigureFormStore.awsAccessKey = value;
};

export const setAwsAccessSecretInput = (value: string) => {
  ConnectorConfigureFormStore.awsAccessSecret = value;
};

export const setAwsExternalIdInput = (value: string) => {
  ConnectorConfigureFormStore.awsExternalId = value;
};

export const setClientIdInput = (value: string) => {
  ConnectorConfigureFormStore.clientId = value;
};

export const setSecretAccessKeyInput = (value: string) => {
  ConnectorConfigureFormStore.secretKey = value;
};

export const setTokenInput = (value: string) => {
  ConnectorConfigureFormStore.token = value;
};

export const setHostUrlInput = (value: string) => {
  ConnectorConfigureFormStore.hostURL = value;
};

export const setPasswordInput = (value: string) => {
  ConnectorConfigureFormStore.password = value;
};

export const setTenantInput = (value: string) => {
  ConnectorConfigureFormStore.tenant = value;
};

export const resetFormInputs = () => {
  ConnectorConfigureFormStore.hostURL = '';
  ConnectorConfigureFormStore.token = '';
  ConnectorConfigureFormStore.password = '';
  ConnectorConfigureFormStore.name = '';
  ConnectorConfigureFormStore.clientId = '';
  ConnectorConfigureFormStore.secretKey = '';
  ConnectorConfigureFormStore.awsRoleArn = '';
  ConnectorConfigureFormStore.awsAccessKey = '';
  ConnectorConfigureFormStore.awsAccessSecret = '';
  ConnectorConfigureFormStore.tenant = '';
};

export const resetAWSExternalIdFormInput = () => {
  ConnectorConfigureFormStore.awsExternalId = '';
};
